import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateTextAutomation as CreateTextAutomationMutation,
    CreateTextAutomationVariables as CreateTextAutomationMutationVariables,
    TextAutomationCreateInput,
} from 'nutshell-graphql-types';

import {refetchSalesAutomationOpenLeadQueries} from '../../app/sales-automation-open-leads';

import CREATE_TEXT_AUTOMATION from '../mutations/create-text-automation.graphql';

export const useCreateTextAutomation = (): {
    createTextAutomation: (input: TextAutomationCreateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createTextAutomation, {loading, error}] = useMutation<
        CreateTextAutomationMutation,
        CreateTextAutomationMutationVariables
    >(CREATE_TEXT_AUTOMATION);

    return {
        createTextAutomation: (input: TextAutomationCreateInput) => {
            return createTextAutomation({
                variables: {textAutomation: input},
                // @ts-expect-error
                refetchQueries: refetchSalesAutomationOpenLeadQueries({stageId: input.stageId}),
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
